import type { Dictionary } from '@emobg/web-utils';

export const STEPS_NAMES = {
  validateBooking: 'validateBooking',
  confirmBooking: 'confirmBooking',
  selectCountry: 'selectCountry',
  selectDocuments: 'selectDocuments',
  validateDocuments: 'validateDocuments',
  updateAddress: 'updateAddress',
  requiredDocuments: 'requiredDocuments',
  requiredClientData: 'requiredClientData',
  summary: 'summary',
} as const;

export const STEPS_ROUTES_NAMES = {
  steps: 'steps',
  welcome: 'welcome',
  confirmBooking: 'confirmBooking',
  validateBooking: 'validateBooking',
  bookingNotFound: 'bookingNotFound',
} as const;

// This variable is not complete
export const STEPS_ERRORS = {
  reservationNotFound: 'reservation_not_found',
  pickupDateDoesNotMatch: 'pick_up_date_does_not_match',
} as const;

export const STEPS_VALIDATION = {
  [STEPS_NAMES.validateBooking]: 'ValidateBooking',
  [STEPS_NAMES.selectCountry]: 'ValidateCountry',
  [STEPS_NAMES.selectDocuments]: 'DocumentsToValidate',
  [STEPS_NAMES.validateDocuments]: 'ValidateDocuments',
  [STEPS_NAMES.updateAddress]: 'ValidateAddress',
} as const;

export const STEPS_NAMES_NAVIGATION: Dictionary = {
  [STEPS_NAMES.validateBooking]: 'bookingDetails',
  [STEPS_NAMES.selectCountry]: 'selectNationality',
  [STEPS_NAMES.validateDocuments]: 'uploadDocuments',
  [STEPS_NAMES.updateAddress]: 'updateInformation',
} as const;

export const STEPS_NAMES_PROGRESS: Dictionary = {
  [STEPS_NAMES.validateBooking]: 1,
  [STEPS_NAMES.selectCountry]: 2,
  [STEPS_NAMES.validateDocuments]: 3,
  [STEPS_NAMES.updateAddress]: 4,
} as const;

export const ROUTE_NAMES_PROGRESS = new Map<string, number>([
  [STEPS_NAMES.validateBooking, 1],
  [STEPS_NAMES.confirmBooking, 2],
  [STEPS_NAMES.selectCountry, 2],
  [STEPS_NAMES.selectDocuments, 3],
  [STEPS_NAMES.requiredDocuments, 3],
  [STEPS_NAMES.validateDocuments, 3],
  [STEPS_NAMES.updateAddress, 4],
  [STEPS_NAMES.requiredClientData, 4],
  [STEPS_NAMES.summary, 4],
]);

export const STEP_PROGRESS_STATUS = {
  done: 'done',
  active: 'active',
  pending: 'pending',
} as const;

export const TOTAL_STEPS = Object.keys(STEPS_NAMES_PROGRESS).length;

export const DEFAULT_STEP_PROGRESS = 1;
